import { render } from "./ActionsAndWorks.vue?vue&type=template&id=0a90bd86&scoped=true"
import script from "./ActionsAndWorks.vue?vue&type=script&lang=js"
export * from "./ActionsAndWorks.vue?vue&type=script&lang=js"

import "./ActionsAndWorks.vue?vue&type=style&index=0&id=0a90bd86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a90bd86"]])

export default __exports__